import React, { useState } from "react";
import "./ProductDetails.css";
import BaseButton from "../Common/BaseButton";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
const ProductName = ({ productname, handleProductRegenerate, previewMode, furtherDetails, loading, handleManualEdit, onHide, sectionId, sectionTitle, isHidden, onUnhide }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [productName, setProductName] = useState(productname);
  const handleEditClick = () => {
    setIsEditing(true);
  };

  const handleDoneClick = () => {
    setIsEditing(false);
    handleManualEdit("title", productName);
  };

  const handleNameChange = (e) => {
    setProductName(e.target.value);
  };
  const handleRegenerate = async (type, formData) => {
    let furtherDetailsToSend = furtherDetails || "";
    let customPromptToSend = null;
    let previousResponseToSend = productName;

    if (typeof formData === "object" && formData !== null) {
      if (formData.reason && formData.reason.trim() !== "") {
        furtherDetailsToSend = formData.reason;
        customPromptToSend = null;
      } else {
        customPromptToSend = {
          goal: formData.goal,
          role: formData.role,
          constraints: formData.constraints,
        };
      }
      // Override with formData previous_response if provided
      if (formData.previous_response) {
        previousResponseToSend = formData.previous_response;
      }
    } else if (typeof formData === "string") {
      furtherDetailsToSend = formData;
      customPromptToSend = null;
    }

    await handleProductRegenerate(type, furtherDetailsToSend, previousResponseToSend, customPromptToSend);
  };

  return (
    <div className="product-section">
      <div className="section-header">
        <div className="section-title">Product Name</div>
       {!previewMode && !loading && ( <div className="button-group">
          {isEditing ? (
            <BaseButton
              className="btn btn-dark"
              children="Done"
              handleClick={handleDoneClick}
            />
          ) : (
            <>
              <BaseButton
                className="outlineprimary"
                children="Regenerate Text"
                imageSrc="/regenerate-text.svg"
                isModalOpen={true}
                handleClick={(formData) => handleRegenerate("title", formData)}  
              />
              {isHidden && onUnhide ? (
                <BaseButton
                  className="outlineprimary"
                  children="Unhide Section"
                  handleClick={onUnhide}
                />
              ) : onHide ? (
                <BaseButton
                  className="outlineprimary"
                  children="Hide Section"
                  handleClick={() => onHide(sectionId, sectionTitle)}
                />
              ) : null}
              <BaseButton
                className="outlineprimary"
                children="Edit Text"
                imageSrc="/edit-text.svg"
                handleClick={handleEditClick}
              />
            </>
          )}
        </div>)}
      </div>
      {loading ? (
       <Skeleton 
       height={40} 
       width={"100%"} 
       
     />
      ) : isEditing ? (
        <input
          type="text"
          value={productName}
          onChange={handleNameChange}
          className="product-title-input form-control"
        />
      ) : (
        <h2 className="product-title" style={{ fontSize: "24px", fontWeight: "300" }}>
          {productName}
        </h2>
      )}
    </div>
  );
};

export default ProductName;
